import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SelectOptionI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-i';
import { SelectOptionLoaderI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { State } from '../../reducers';
import { getOneClickTimeWindows } from '@ordersnproducts/modules/one-click-order/selectors/one-click-time-windows.selector';
import { OneClickPreviewField } from '../../util/constants/preview-fields';

const morningCode = '0800-1300EG';

@Injectable()
export class OneClickTimeWindowsLoaderService implements SelectOptionLoaderI {
  constructor(private store: Store<State>) {}

  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(getOneClickTimeWindows),
      map((timeWindows) => {
        return timeWindows.map((timeWindow) => {
          return {
            id: timeWindow.timeWindowId,
            name: timeWindow.timeWindowDesc,
          };
        });
      }),
    );
  }
}

@Injectable()
export class OneClickTimeWindowDefaultMorningLoaderService implements SelectOptionLoaderI {
  constructor(private store: Store<State>) {}

  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(getOneClickTimeWindows),
      map((timeWindows) => {
        const morningTimeWindow = timeWindows.find((item) => item.timeWindowCode === morningCode);
        if (morningTimeWindow) {
          formGroup.get(OneClickPreviewField.TimeWindow).setValue(morningTimeWindow.timeWindowId);
        }
        return timeWindows.map((timeWindow) => {
          return {
            id: timeWindow.timeWindowId,
            name: timeWindow.timeWindowDesc,
          };
        });
      }),
    );
  }
}
